import { render, staticRenderFns } from "./transactionLog2.vue?vue&type=template&id=3745a060&scoped=true"
import script from "./transactionLog2.vue?vue&type=script&lang=js"
export * from "./transactionLog2.vue?vue&type=script&lang=js"
import style0 from "./transactionLog2.vue?vue&type=style&index=0&id=3745a060&prod&lang=scss&scoped=true"
import style1 from "./transactionLog2.vue?vue&type=style&index=1&id=3745a060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3745a060",
  null
  
)

export default component.exports